/**
 * Characters that render as nothing: whitespace (`\s`), Unicode format
 * characters (`\p{Cf}`: zero-width space, zero-width (non-)joiners, word
 * joiner, soft hyphen, BOM, ...) and the filler glyphs that are letters by
 * category but draw blank (Hangul fillers, Braille blank).
 *
 * `String.prototype.trim()` only covers the first group, so a message made of
 * `\u200B` passes a `trim()` check while looking empty to the user.
 */
const INVISIBLE_CHARACTERS = /[\s\p{Cf}\u115F\u1160\u2800\u3164\uFFA0]/gu;

/**
 * Whether `value` contains at least one character the user can see.
 * Emoji sequences stay visible: only their zero-width joiners are invisible.
 */
export function hasVisibleText(value: string | null | undefined): boolean {
  return !!value && value.replace(INVISIBLE_CHARACTERS, '').length > 0;
}
